import { Card, ContentGrid, Heading1, P, theme } from '@ovotech/element-v5';
import { ButtonGroup } from '@/src/components/ButtonGroup/ButtonGroup';

import styled from 'styled-components';

export const StyledCard = styled(Card)`
  /* --- MOBILE STYLES (Default) --- */
  display: flex;
  padding: 32px 24px;
  gap: 24px;
  border-radius: 0px;
  flex-direction: column;

  ${({ theme }) => theme.mediaQueries.smallAndUp} {
    align-items: flex-start;
    align-self: stretch;
    padding: 16px;
    gap: 16px;
  }
`;

export const StyledP = styled(P)`
  max-width: 600px;
`;
export const StyledHeading = styled(P)`
  font-weight: ${theme.font.weight.bold};
  color: ${theme.color.surface.onSurface};
  font-size: ${theme.font.size.lg.mediaQuery.lg};
  line-height: ${theme.font.lineHeight.lg.mediaQuery.lg};
  letter-spacing: ${theme.font.letterSpacing.lg.mediaQuery.lg};
`;

export const StyledHeading1 = styled(Heading1)`
  color: ${theme.color.brand.onBrand};
  padding: 12px 16px;
`;

export const SpacedBtnGroup = styled(ButtonGroup)`
  align-items: flex-start;
  flex-direction: column;
  > div {
    /* Override the default '100%' width to make buttons shrink-to-fit their content */
    width: auto;
    flex-direction: row-reverse;
  }

  /* We only need to define the override for DESKTOP screens */
  ${({ theme: { mediaQueries } }) => `
    ${mediaQueries.smallAndUp} {
      flex-direction: row-reverse;
      justify-content: space-between;
    }
  `}
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  ${({ theme: { mediaQueries } }) => `
    ${mediaQueries.smallAndUp} {
      justify-content: flex-end;
    }
  `};
`;

export const FullWidthContentGrid = styled(ContentGrid)`
  gap: ${theme.space['400']};
  margin-top: ${theme.space['800']};
  padding: 0;

  ${({ theme: { mediaQueries } }) => `
    ${mediaQueries.smallAndUp} {
    margin-left: -1.6rem;
    gap: ${theme.space['800']};
  }
    `};
`;
